import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  InputLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Applicant, ApplicationProps } from '../../redux-store/types/api-types';
import {
  addressTypesMasters,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  IdTypeMasters,
  ReasonMaster,
  USER_ROLES,
  SAVE_LATER_VALIDATION_CHECK,
} from '../../utils/constant';
import {
  applicationComparison,
  applyRoleBasedStatus,
  getApplicantName,
  removeSingleQuote,
  saveForLater,
  getStep,
  FatcaDeclaration,
  IsOutBoundFundFlow,
} from '../../utils/utilityFunctions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { FATCAValidationSchema } from '../../utils/schema';
import { useSnackbar } from 'notistack';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import MFCheckbox from '../../lib/formik/Checkbox';
import { showError } from '../../redux-store/actions/auth';
import { GridItem } from './distributorDetails';
import FieldValidationNote from './FieldValidationNote';
import { FatcaDeclarationInd } from '../DocumentDeclairations';

export type Values = {
  applicants: Partial<Applicant>[];
  saveType: string;
  countryDropdown: string[];
  countriesOfBirthList: string[];
};

const applicantObj = (setInitialValue: boolean) => {
  return {
    typeOfAddressProvidedAtKRA: '',
    taxIdResidentOfAnyCountryOtherThanIndia: 'No',
    placeOfBirth: '',
    countryOfBirth: '',
    countryOfNationality: '',
    countryOfResidence: '',
    taxCountryName: '',
    taxID: '',
    idType: '',
    nameOfEntity: '',
    dateOfIncorporation: '',
    cityOfIncorporation: '',
    countryOfIncorporation: '',
    entityExcemptionCode: '',
    idTypeOthers: '',
    tinNotAvailableReason: '',
    othersTinNotAvailableReason: '',
    usPerson: '',
    fatcaDeclaration: true,
  };
};

const initialValues: Values = {
  applicants: [
    {
      ...applicantObj(true),
      wishToUploadFatcaDocument: false,
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
  countriesOfBirthList: [],
};

export const TermsAndConditions = ({ onClose, open }: { onClose: any; open: any }): JSX.Element => {
  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 800,
            p: { xs: 2, sm: '15px 5px 35px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <IconButton onClick={onClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '90%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'start',
              fontFamily: 'Work Sans,sans-serif',
            },
          }}>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              1.{' '}
            </Typography>
            Details under FATCA & CRS: The Central Board of Direct Taxes has notified Rules 114F to
            114H, as part of the Income-tax Rules, 1962, which Rules require Indian financial
            institutions such as the Bank to seek additional personal, tax and beneficial owner
            information and certain certifications and documentation from all our account holders.
            In relevant cases, information will have to be reported to tax authorities/ appointed
            agencies. Towards compliance, we may also be required to provide information to any
            institutions such as withholding agents for the purpose of ensuring appropriate
            withholding from the account or any proceeds in relation thereto. Should there be any
            change in any information provided by you,please ensure you advise us promptly, i.e.,
            within 30 days.
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              2.{' '}
            </Typography>
            If you have any questions about your tax residency, please contact your tax advisor. If
            you are a US citizen or resident or green card holder, please include United States in
            the foreign country information field along with your US Tax Identification Number. It
            is mandatory to supply a TIN or functional equivalent if the country in which you are
            tax resident issues such identifiers. If no TIN is yet available or has not yet been
            issued, please provide an explanation and attach this to form
          </Typography>
        </Box>
      </Dialog>
    </>
  );
};

export const GuidelinesForFatca = ({ onClose, open }: { onClose: any; open: any }): JSX.Element => {
  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 800,
            p: { xs: 2, sm: '15px 5px 35px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <IconButton onClick={onClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '90%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'start',
              fontFamily: 'Work Sans,sans-serif',
            },
          }}>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>1. Who is US person?</Typography>
            In case of individuals, U.S. person means a citizen or Resident of the United States.
            Persons who would qualify as US person could be born in the United States, Born outside
            the united states of a US parents, Naturalized Citizens, Green Card Holders,Tax
            residents.
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              2. Who is a reportable person (non US) under common reporting standards (CRS)?{' '}
            </Typography>
            Under common reporting standards (CRS), Reportable person means tax resident of a
            reportable foreign jurisdiction other than US
          </Typography>

          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              {` 3. Document to be submitted if Customer's Country of birth is US but Declares that
              he/she is not a US person`}
            </Typography>
            <Typography>
              • Certificate of relinquishment of citizenship (loss of nationality certificate)
            </Typography>
            <Typography>
              • Self certification for stating reason for not having such a certificate despite
              relinquishing US citizenship
            </Typography>
            <Typography>
              • Self certification for stating reasons for not obtaining US citizenship at birth.
            </Typography>
          </Typography>

          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              4. Towards compliance with tax information sharing laws, such as FATCA, we would be
              required to seek additional personal, tax and
            </Typography>
            <Typography>
              • Beneficial owner information and certain certifications and documentation from our
              account holders. Such information may be sought either at the time of account opening
              or any time subsequently. In certain circumstances we may be obliged to share
              information on your account with relevant tax authorities. If you have any questions
              about your tax residency, please contact your tax advisor. Should there be any change
              in any information provided by you, please ensure you advise us promptly, i.e., within
              30 days. Towards compliance with such laws, we may also be required to provide
              information to any institutions such as withholding agents for the purpose of ensuring
              appropriate withholding from the account or any proceeds in relation thereto. As may
              be required by domestic or overseas regulators/ tax authorities, we may also be
              constrained to withhold and pay out any sums from your account or close or suspend
              your account(s).
            </Typography>
            <Typography>
              • If any controlling person of the entity is a citizen or resident or green card
              holder of outside India, please include all such foreign country information field
              along with the relevantTax Identification Number.
            </Typography>
            <Typography>
              • Also note that you may receive more than one request to provide this information, if
              you have multiple relationships with us or our group entities. Therefore it is
              important that you respond to our request, even if you believe that you have already
              provided this information earlier Please note that above information is provided only
              for quick reference to customers. You are requested to refer Rule 114F, 114G and 114H
              of Income-tax Rules, 1962 consult a legal/tax advisor for any clarification.
            </Typography>
          </Typography>
        </Box>
      </Dialog>
    </>
  );
};

const FatcaDetails = ({
  applicantName,
  index,
  values,
  nationalitiesMdmsResponse,
  countriesOfBirthList,
  createdAt,
  fundFlowType,
}: {
  applicantName: string;
  index: number;
  values: Partial<Applicant>;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  countriesOfBirthList: mdmsCountriesList[];
  createdAt: string;
  fundFlowType: string;
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isFieldDisabled = [USER_ROLES.POAAPPROVER].includes(role);

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <SubHeading>FATCA Details of {applicantName} Applicant</SubHeading>
      {/* <Grid item xs={12}>
        <MFCheckbox
          name={`applicants.${index}.wishToUploadFatcaDocument`}
          label={'Wish to upload FATCA-CRS Declaration'}
          sx={{ my: 2 }}
          disabled={isFieldDisabled}
        />
      </Grid> */}
      {/* {!values.wishToUploadFatcaDocument && ( */}
      <>
        {/* <Grid item xs={12} sm={6}>
            <MFSelectField
              name={`applicants.${index}.typeOfAddressProvidedAtKRA`}
              label="Type of Address proof provided *"
              items={addressTypesMasters.map((address) => ({ key: address, value: address }))}
            />
          </Grid> */}
        <Grid item xs={12}>
          <UseRadioGroup
            formLabel="Are you a Tax Resident of any country other than India *"
            name={`applicants.${index}.taxIdResidentOfAnyCountryOtherThanIndia`}
            items={[
              { label: 'No', value: 'No' },
              { label: 'Yes', value: 'Yes' },
            ]}
            disabled={isFieldDisabled}
          />
        </Grid>
        {/* {applicant?.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && ( */}
        <>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.placeOfBirth`}
              label="Place of Birth *"
              placeholder="Enter Place of Birth"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {/* <MFTextField
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            placeholder="Enter Country of Birth"
            disabled={isFieldDisabled}
          /> */}
            <SearchableSelect
              name={`applicants.${index}.countryOfBirth`}
              label="Country of Birth *"
              items={countriesOfBirthList.map((nationality) => ({
                key: nationality?.name,
                value: nationality?.name,
              }))}
              disabled={isFieldDisabled}
              searchFieldPlaceholder={'Search Country'}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {/* <MFTextField
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            placeholder="Enter Country of Nationality"
            disabled={isFieldDisabled}
          /> */}
            <SearchableSelect
              name={`applicants.${index}.countryOfNationality`}
              label="Country of Citizenship/Nationality *"
              items={nationalitiesMdmsResponse.map((nationality) => ({
                key: nationality?.name,
                value: nationality?.name,
              }))}
              disabled={isFieldDisabled}
              searchFieldPlaceholder={'Search Country'}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
              <SearchableSelect
                name={`applicants.${index}.countryOfResidence`}
                label="Country of Residence*"
                items={nationalitiesMdmsResponse.map((nationality) => ({
                  key: nationality?.name,
                  value: nationality?.name,
                }))}
                disabled={isFieldDisabled}
                searchFieldPlaceholder={'Search Country'}
              />
            </Grid> */}
          {values?.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && (
            <>
              <Grid item xs={12} sm={6}>
                <SearchableSelect
                  name={`applicants.${index}.taxCountryName`}
                  label="Country of Tax Residency/TIN Issuing Country *"
                  items={nationalitiesMdmsResponse.map((nationality) => ({
                    key: nationality?.name,
                    value: nationality?.name,
                  }))}
                  disabled={isFieldDisabled}
                  searchFieldPlaceholder={'Search Country'}
                />
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <MFSelectField
                  name={`applicants.${index}.idType`}
                  label="ID Type *"
                  items={IdTypeMasters.map((_idType) => ({
                    key: _idType,
                    value: _idType,
                  }))}
                  disabled={isFieldDisabled}
                />
              </Grid> */}
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={`applicants.${index}.taxID`}
                  label="TIN/Equivalent Number"
                  placeholder="Enter TIN/Equivalent Number"
                  disabled={isFieldDisabled}
                />
              </Grid>
              {!values.taxID && (
                <>
                  {/* <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.idTypeOthers`}
                      label="Please Specify ID Type *"
                      placeholder="Enter ID Type"
                      disabled={isFieldDisabled}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                      <MFSelectField
                        name={`applicants.${index}.tinNotAvailableReason`}
                        label="Reason (If TIN is not available)"
                        items={Object.keys(ReasonMaster).map((reason) => ({
                          key: ReasonMaster[reason].code,
                          value: reason,
                        }))}
                        disabled={isFieldDisabled}
                      />
                      <Typography component="span" ml={1} sx={{ cursor: 'pointer' }}>
                        <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
                      </Typography>
                    </Box>
                  </Grid>
                  {ReasonMaster[values.tinNotAvailableReason || '']?.code ===
                    ReasonMaster.reason_c.code && (
                    <Grid item xs={12} sm={6}>
                      <MFTextField
                        name={`applicants.${index}.othersTinNotAvailableReason`}
                        label="Please Specify Reason *"
                        placeholder="Enter Reason"
                        disabled={isFieldDisabled}
                      />
                    </Grid>
                  )}
                </>
              )}
            </>
          )}
          <Grid item xs={12} sm={6} sx={{ pt: '25px !important' }}>
            <UseRadioGroup
              formLabel="Are You a US Person *"
              name={`applicants.${index}.usPerson`}
              items={[
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
              ]}
              disabled={isFieldDisabled}
              info="(US Visa/Passport/green card holder)"
            />
          </Grid>

          <Grid item xs={12} sx={{ mt: 2 }}>
            {FatcaDeclarationInd()}
          </Grid>

          {/* {IsOutBoundFundFlow(fundFlowType) && (
            <Grid item xs={12} sx={{ mt: 2 }}>
              <MFCheckbox
                name={`applicants.${index}.fatcaDeclarationOutbound`}
                label={FatcaDeclarationInd()}
              />
            </Grid>
          )} */}
          {!IsOutBoundFundFlow(fundFlowType) && (
            <Grid item xs={12} sx={{ mt: 2 }}>
              <MFCheckbox
                name={`applicants.${index}.fatcaDeclaration`}
                label={FatcaDeclaration(createdAt || '')}
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'rgba(0,0,0,0.7)',
                  alignItems: 'flex-start',
                  '.MuiTypography-root': {
                    fontSize: 15,
                    fontWeight: 500,
                  },
                }}
              />
            </Grid>
          )}
          {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.nameOfEntity`}
              label="Name of Entity"
              placeholder="Enter Name of Entity"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Date of Incorporation"
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              maxDate={minDateForContributor()}
              name={`applicants.${index}.dateOfIncorporation`}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              value={applicant.dateOfBirth || minDateForContributor().toString()}
              onChange={(newValue) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant, ind) => {
                    if (index === ind) {
                      return {
                        ...applicant,
                        dateOfIncorporation: newValue?.toString(),
                      };
                    }
                    return applicant;
                  }),
                });
              }}
              textFieldStyles={{
                'label + &': {
                  mt: 4,
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #DDEAF3',
                },
                '& .MuiOutlinedInput-root': {
                  position: 'relative',
                  backgroundColor: 'common.white',
                  border: '1px solid #DDEAF3',
                  fontSize: 16,
                  '&:hover': {
                    borderColor: 'primary.main',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 0,
                    },
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    border: 0,
                  },
                  '.MuiInputBase-input': {
                    p: '10px 12px',
                  },
                  '&:focus-visible': {
                    outline: 'none',
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.cityOfIncorporation`}
              label="City of Incorporation"
              placeholder="Enter City of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.countryOfIncorporation`}
              label="Country of Incorporation"
              placeholder="Enter Country of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.entityExcemptionCode`}
              label="Entity Exemption Code"
              placeholder="Enter Entity Exemption Code"
            />
          </Grid> */}
        </>
        {/* )} */}
      </>
      {/* )} */}
      <Dialog
        onClose={handleClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 800,
            p: { xs: 2, sm: '15px 5px 35px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '90%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'start',
              fontFamily: 'Work Sans,sans-serif',
            },
          }}>
          <Typography sx={{ fontSize: 16, fontWeight: 400 }}>
            *If a TIN is unavailable, please provide the appropriate reason A, B or C as defined
            below:
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason A –{' '}
            </Typography>
            {ReasonMaster.reason_a.description}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason B –{' '}
            </Typography>
            {ReasonMaster.reason_b.description}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason C –{' '}
            </Typography>
            {ReasonMaster.reason_c.description}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              sx={{ minWidth: { xs: '170px', sm: '220px' }, mt: 3 }}
              onClick={handleClose}>
              Done
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default function Fatca(): JSX.Element {
  const [fatcaDetails, setFatcaDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openGuidelines, setOpenGuidelines] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [countriesOfBirthList, setCountriesOfBirthList] = useState<mdmsCountriesList[]>([]);
  const { flowType = '', fundFlowType = '' } = application || {};
  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        const countryList = nationalitiesMdmsMasters.countries.concat(
          nationalitiesMdmsMasters.eddCountries
        );
        setMdmsCountriesList(countryList);
        const countriesOfBirth = countryList.concat(nationalitiesMdmsMasters.blackListCountries);
        setCountriesOfBirthList(countriesOfBirth);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  useEffect(() => {
    const { applicants = [] } = application || {};
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        const countryList = nationalitiesMdmsMasters.countries.concat(
          nationalitiesMdmsMasters.eddCountries
        );
        setMdmsCountriesList(countryList);
        setFatcaDetails({
          ...fatcaDetails,
          applicants: applicants?.map((applicant) => ({
            typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
            taxIdResidentOfAnyCountryOtherThanIndia:
              applicant.taxIdResidentOfAnyCountryOtherThanIndia || 'No',
            placeOfBirth: applicant.placeOfBirth || '',
            countryOfBirth: applicant.countryOfBirth || applicant.nationality || '',
            countryOfNationality: applicant.countryOfNationality || applicant.nationality || '',
            countryOfResidence: applicant.countryOfResidence || '',
            taxCountryName: applicant.taxCountryName || '',
            taxID: applicant.taxID || applicant.taxIdNumber || '',
            idType: applicant.idType || 'OTHERS' || '',
            nameOfEntity: applicant.nameOfEntity || '',
            dateOfIncorporation: applicant.dateOfIncorporation || '',
            cityOfIncorporation: applicant.cityOfIncorporation || '',
            countryOfIncorporation: applicant.countryOfIncorporation || '',
            entityExcemptionCode: applicant.entityExcemptionCode || '',
            idTypeOthers: applicant.idTypeOthers || '',
            tinNotAvailableReason: applicant.tinNotAvailableReason || '',
            othersTinNotAvailableReason: applicant.othersTinNotAvailableReason || '',
            usPerson: applicant.usPerson || '',
            fatcaDeclaration: applicant.fatcaDeclaration || false,
            wishToUploadFatcaDocument: false,
          })),
          countryDropdown: countryList.map((list) => list?.name),
          countriesOfBirthList: countryList
            .concat(nationalitiesMdmsMasters.blackListCountries)
            .map((list) => list?.name),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleOpenGuideline = () => {
    setOpenGuidelines(true);
  };
  const handleCloseGuideline = () => {
    setOpenGuidelines(false);
  };

  const handleOpenTermsAndConditions = () => {
    setOpen(true);
  };
  const handleCloseTermsAndConditions = () => {
    setOpen(false);
  };

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants: existingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { applicants, saveType } = values;
      const updatedPayload = existingApplicants.map((applicant, index: number) => {
        if (
          applicants[index].fatcaDeclaration === false &&
          !IsOutBoundFundFlow(fundFlowType) &&
          !applicants[index].wishToUploadFatcaDocument
        ) {
          throw 'Declaration is required';
        }
        const {
          // dateOfBirth = '',
          dateOfIncorporation = '',
          ...rest
        } = applicants[index];

        if (applicants[index].wishToUploadFatcaDocument) {
          return {
            ...applicant,
            ...applicantObj(true),
            wishToUploadFatcaDocument: applicants[index].wishToUploadFatcaDocument,
            dateOfIncorporation: null,
          };
        } else {
          return {
            ...applicant,
            // dateOfBirth: dateOfBirth ? dateOfBirth : null,
            dateOfIncorporation: dateOfIncorporation ? dateOfIncorporation : null,
            ...rest,
            placeOfBirth: removeSingleQuote(rest.placeOfBirth),
            taxCountryName:
              rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' ? rest.taxCountryName : '',
            taxID: rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' ? rest.taxID : '',
            idType: rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' ? rest.idType : '',
            idTypeOthers:
              rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && rest.idType === 'OTHERS'
                ? removeSingleQuote(rest.idTypeOthers)
                : '',
            tinNotAvailableReason:
              rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' && !rest.taxID
                ? rest.tinNotAvailableReason
                : '',
            othersTinNotAvailableReason:
              rest.taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' &&
              !rest.taxID &&
              ReasonMaster[rest.tinNotAvailableReason || '']?.code === ReasonMaster.reason_c.code
                ? removeSingleQuote(rest.othersTinNotAvailableReason)
                : '',
            fatcaDeclaration: !IsOutBoundFundFlow(fundFlowType)
              ? applicant.fatcaDeclaration || true
              : false,
            wishToUploadFatcaDocument: false,
          };
        }
      });
      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedPayload,
        currentStep: !!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
      });
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedPayload,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: getStep(5, isSaveLater),
              ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
              //!!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
            flowType,
          })
        );
        !isSaveLater
          ? history.push('nominee-details', { id, applicant1ReferenceId })
          : history.push(
              saveForLater(role, id, applicant1ReferenceId, application as ApplicationProps)
            );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('nominee-details', { id, applicant1ReferenceId })
          : history.push(
              saveForLater(role, id, applicant1ReferenceId, application as ApplicationProps)
            );
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={fatcaDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, FATCAValidationSchema, true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <GridItem>
            <Typography component="div" sx={{ display: 'flex' }}>
              <InputLabel
                shrink
                sx={{
                  transform: 'unset',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'rgba(0,0,0,0.7)',
                  mr: 1,
                }}>
                {'Terms and conditions'}
              </InputLabel>
              <InfoOutlinedIcon
                color="info"
                fontSize="small"
                onClick={handleOpenTermsAndConditions}
                sx={{ cursor: 'pointer' }}
              />
            </Typography>
            <Typography component="div" sx={{ display: 'flex' }}>
              <InputLabel
                shrink
                sx={{
                  transform: 'unset',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'rgba(0,0,0,0.7)',
                  mt: 1,

                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                }}>
                {'Guidelines'}
                <InfoOutlinedIcon
                  color="info"
                  fontSize="small"
                  sx={{ ml: 1, cursor: 'pointer' }}
                  onClick={handleOpenGuideline}
                />
              </InputLabel>
            </Typography>
          </GridItem>
          <TermsAndConditions onClose={handleCloseTermsAndConditions} open={open} />
          <GuidelinesForFatca onClose={handleCloseGuideline} open={openGuidelines} />
          {values.applicants.map((applicant, index) => (
            <FatcaDetails
              applicantName={getApplicantName(index + 1)}
              index={index}
              key={index}
              values={applicant}
              nationalitiesMdmsResponse={mdmsCountriesList}
              countriesOfBirthList={countriesOfBirthList}
              createdAt={application?.createdAt || ''}
              fundFlowType={fundFlowType}
            />
          ))}
          <FieldValidationNote />
          <ProceedSaveLater
            goToPreviousStep={() => {
              history.push('additional-KYC-details');
            }}
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
        </Grid>
      )}
    </Formik>
  );
}
